let errorCode = [{
    code: 110000,
    value: '搜索词为空'
  }, {
    code: 110010,
    value: '请求体为空'
  }, {
    code: 120003,
    value: '查询实时库存的参数异常'
  }, {
    code: 120029,
    value: '查询快递和快递价格的参数异常'
  }, {
    code: 120030,
    value: '快递编码为空'
  }, {
    code: 120031,
    value: '快递编码无效'
  },
  {
    code: 120201,
    value: '校验库存的参数异常'
  },
  {
    code: 120203,
    value: '商品编码异常,无法在仓库层查询到对应的物料'
  }, {
    code: 120441,
    value: '通过省份编码查询优势快递的参数异常'
  },
  {
    code: 120442,
    value: '省编码无效'
  },
  {
    code: 130201,
    value: '计算时间的单据信息为空'
  },
  {
    code: 130202,
    value: '下单时间为空'
  },
  {
    code: 130203,
    value: '配送规则必须配置'
  },
  {
    code: 130204,
    value: '预计到店时间规则必须配置'
  },
  {
    code: 130308,
    value: '查询供应商商品编码的参数异常'
  },
  {
    code: 130509,
    value: '查询下单联系人 id 的参数异常'
  },
  {
    code: 130510,
    value: '有一个以上的联系人'
  },
  {
    code: 130511,
    value: '下单联系人 id 为空'
  },
  {
    code: 130613,
    value: '查询收货地址 id 的参数异常'
  },
  {
    code: 130614,
    value: '收货信息查询到多个收货地址'
  },
  {
    code: 130615,
    value: '省市区编码异常，无法查询到对应的数据'
  },
  {
    code: 130616,
    value: '收货地址 id 为空'
  },
  {
    code: 130617,
    value: '送货上门经纬度为空'
  },
  {
    code: 130619,
    value: '百度地理编码异常'
  },
  {
    code: 130620,
    value: '计算送货上门距离异常'
  },
  {
    code: 130621,
    value: '不在送货上门范围内'
  },
  {
    code: 130622,
    value: '送货上门地址不够精确'
  },
  {
    code: 130701,
    value: '查询的物料信息列表为空'
  },
  {
    code: 130702,
    value: '缓存的统计信息为空'
  },
  {
    code: 130707,
    value: '查询物料详情的物料列表参数为空'
  },
  {
    code: 130708,
    value: '通过物料列表参数查询物料详情结果异常'
  }
]

export default errorCode;